import FeatureGates from '@atlaskit/feature-gate-js-client';

import { GateNames } from './gate-keys';

export function fg(gateName: GateNames): boolean {
	return FeatureGates.checkGate(gateName);
}
